<template>
	<div class="alert alert-warning">
		<icon name="exclamation-triangle"/> Preview Not Available
	</div>
</template>

<script>
	export default {}
</script>